export default __webpack_public_path__ + "c2b50f4a7d908c8d06f5b05ec135e166.woff";